import React, { useMemo, useState, useEffect, useRef } from "react";
import TutorialDataService from "../services/tutorial.service";
import EditTutorial from "./EditTutorial";

import R7Table from "./R7Table";
import { firestore } from "../firebase";

const TutorialsPage = () => {
  // Set default as null so we
  // know if it's still loading
  const [loading, setLoading] = useState(true);
  const [tutorials, setTutorials] = useState([]);
  const [comments, setComments] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: "Stato",
        accessor: (value) => value.published.toString(),
        Cell: ({ value }) =>
          value === "true" ? (
            <span className="green-dot"></span>
          ) : (
            <span className="red-dot"></span>
          ),
      },
      {
        Header: "Id",
        accessor: "uniqueId", // accessor is the "key" in the data
      },
      {
        Header: "Nome esercizio",
        accessor: "title", // accessor is the "key" in the data
        Cell: ({ row, value }) => (
          <button
            className="btn btn-link"
            onClick={() => {
              setCurrentTutorial(row.original);
            }}
          >
            {value}
          </button>
        ),
      },
      {
        Header: "Indirizzo",
        accessor: "address",
      },
      {
        Header: "Categoria",
        accessor: (value) => {
          const arr = [];
          Object.keys(value.catApp).map((x, i) => {
            arr.push(value.catApp[x]);
          });
          return arr.join();
        },
      },
      {
        id: "cfb",
        Header: "Carta Famiglia Base",
        accessor: (value) => value.sconti[0].status.toString(),
        Cell: ({ value }) => (value === "true" ? "SI" : "NO"),
      },
      {
        id: "cfp",
        Header: "Carta Famiglia +",
        accessor: (value) => value.sconti[1].status.toString(),
        Cell: ({ value }) => (value === "true" ? "SI" : "NO"),
      },
      {
        id: "cg",
        Header: "Carta Oro",
        accessor: (value) => value.sconti[2].status.toString(),
        Cell: ({ value }) => (value === "true" ? "SI" : "NO"),
      },
      {
        Header: "Segnalazioni",
        accessor: (value) => value.id,
        Cell: ({ value }) =>
          comments.filter(c => !c.read && c.tutorial === value).length > 0 ? (
            <span className="orange-dot"></span>
          ) : (
            <span className="gray-dot"></span>
          ),
      },
    ],
    [tutorials, comments]
  );

  useEffect(() => {
    // Remove subscriptions on component unmount
    const unsubscribers = listenForTutorials();
    return () => {
      unsubscribers.forEach(u => u());
    }
  }, []);

  const listenForTutorials = () => {
    setLoading(true);
    const unsubscribeTutorials = TutorialDataService.getAll()
      .orderBy("title", "asc")
      .onSnapshot(
        (snapshot) => {
          const allMessages = [];
          snapshot.forEach((doc) => {
            allMessages.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          setTutorials(allMessages);
          setLoading(false);
        },
        (error) => {
          console.error(error);
          setLoading(false);
        }
      );

    const unsubscribeComments = firestore.collectionGroup('comments')
      .orderBy('createdAt', 'desc')
      .onSnapshot(snapshot => {
        const tempComments = [];
        snapshot.forEach(comment => {
          tempComments.push({
            ...comment.data(),
            id: comment.id,
            // snapshot.ref.parent = 'comments' subcollection
            // snapshot.ref.parent.parent = actual document parent
            tutorial: comment.ref.parent.parent.id,
          })
        })
        setComments(tempComments);
      })
    return [unsubscribeTutorials, unsubscribeComments];
  };

  const [currentTutorial, setCurrentTutorial] = useState(null);

  return (
    <div className="container">
      {!currentTutorial ? (
        <div className="list row">
          <div className="col-md-12">
            <h4>Lista Esercizi</h4>

            <ul className="list-group">
              {!loading && (
                  <R7Table
                    columns={columns}
                    data={tutorials}
                    setActiveTutorial={setCurrentTutorial}
                  />
                )}
            </ul>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-md-12">
            <div className="container">
              <div className="form-group">
                <button
                  className="btn btn-outline-dark"
                  onClick={() => {
                    setCurrentTutorial(null);
                  }}
                >
                  Torna alla lista degli esercizi
                </button>
              </div>
            </div>
            {/* <Tutorial tutorial={currentTutorial} /> */}
            <EditTutorial
              tutorial={currentTutorial}
              setActiveTutorial={setCurrentTutorial}
              comments={comments.filter(c => c.tutorial === currentTutorial.id)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TutorialsPage;
